import { getKeySignature, getSymmetricKey } from "../dataEncryption";
import { loadJwt } from "../dwclient/localstorage/jwtStorage";
import { baseUrl } from "../dwclient/dwcommonutils";
import { apiVersion } from "../dwclient/dwcommonutils";

const ZIP_DOWNLOADS_DB = "zip-downloads-db";

export const zipDownload = async (fileList, node, onDownloadProgress, signal) => {
  //console.log("selectedNode", node);
  // path, size
  // We are passing them through by IndexedDB
  const authToken = await loadJwt();
  signal?.throwIfAborted();
  if (authToken === null) {
    return;
  }
  const keySignature = getKeySignature();
  if (keySignature === null) {
    return;
  }
  await removeAll();
  signal?.throwIfAborted();
  if (fileList.length === 0) {
    return;
  }
  const nodeAbsolutePath = makeNodeAbsolutePath(node, fileList);
  //console.log(nodeAbsolutePath);
  for (const file of fileList) {
    const zipPath = makeZipPath(file.path, nodeAbsolutePath);
    await saveUploadToDB(crypto.randomUUID(), file.path, zipPath, authToken, keySignature, file.size);
    signal?.throwIfAborted();
  }
  //saveUploadToDB(crypto.randomUUID(), "/Uploaded/eper.jpg", authToken, keySignature, 45634);
  //saveUploadToDB(crypto.randomUUID(), "/Uploaded/500m.bin", authToken, keySignature, 524_288_000);

  if (onDownloadProgress) {
    navigator.serviceWorker.addEventListener("message", (event) => {
      onDownloadProgress(event.data);
    });
  }

  const downloadId = crypto.randomUUID();
  const cancelDownload = () => {
    void cancelZipDownload(downloadId);
  };
  signal?.addEventListener("abort", cancelDownload, { once: true });
  signal?.throwIfAborted();

  const link = document.createElement("a");
  link.href = `/download-zip?downloadId=${encodeURIComponent(downloadId)}`;
  link.download = "Dwinity Files.zip";
  document.body.appendChild(link);
  link.click();
  link.remove();

  /*var a = document.createElement("a");
  a.href = "/download-zip";
  var evt = document.createEvent("MouseEvents");
  evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, true, false, false, false, 0, null);
  a.dispatchEvent(evt);*/
};

export async function cancelZipDownload(downloadId) {
  if (!navigator.serviceWorker?.getRegistration) return;
  const registration = await navigator.serviceWorker.getRegistration("/download-zip");
  const worker = registration?.active ?? registration?.waiting ?? registration?.installing;
  worker?.postMessage({ type: "cancel-zip-download", downloadId });
}

export function makeNodeAbsolutePath(node, fileList) {
  let nodeAbsolutePath;
  if (node !== undefined) {
    nodeAbsolutePath = makeNodeAbsolutePathFromNode(node);
  } else {
    nodeAbsolutePath = makeNodeAbsolutePathFromFiles(fileList);
  }
  if (nodeAbsolutePath.startsWith("/Uploaded")) {
    nodeAbsolutePath = "User Files" + nodeAbsolutePath;
  }
  return nodeAbsolutePath;
}

function makeNodeAbsolutePathFromNode(node) {
  let nodeAbsolutePath = makeNodeAbsolutePathRecursive(node, node.value);
  if (nodeAbsolutePath === "/") {
    nodeAbsolutePath = "User Files";
  } else {
    return nodeAbsolutePath;
  }
  return nodeAbsolutePath;
}

function makeNodeAbsolutePathFromFiles(fileList) {
  console.log("fileList", fileList);
  if (fileList === undefined || fileList.length === 0) {
    return "/";
  }
  const pathList = fileList.map((file) => file.path);
  console.log("pathList", pathList);
  let common = undefined;
  for (const path of pathList) {
    const processedPath = path.startsWith("/Uploaded") ? "User Files" + path : path;
    console.log("common", common);
    console.log("path", processedPath);
    common = findLongestCommonPath(common, processedPath);
    console.log("new common", common);
  }
  return common;
}

function findLongestCommonPath(path1, path2) {
  if (path1 === undefined) {
    return path2;
  }
  if (path2 === undefined) {
    return path1;
  }
  let parts1 = path1.split("/");
  let parts2 = path2.split("/");
  let minLength = Math.min(parts1.length, parts2.length);
  let commonParts = [];

  for (let i = 0; i < minLength; i++) {
    if (parts1[i] === parts2[i]) {
      commonParts.push(parts1[i]);
    } else {
      break;
    }
  }

  return commonParts.length > 0 ? commonParts.join("/") : "";
}

function makeNodeAbsolutePathRecursive(node, relativePath) /*:string|undefined*/ {
  for (const childNode of node.content) {
    if (childNode.properties.isFile) {
      const toRemove = relativePath + "/" + childNode.value;
      //console.log("toRemove", toRemove);
      //console.log("fileStorageId", childNode.properties.fileStorageId);
      if (childNode.properties.fileStorageId.endsWith(toRemove)) {
        return childNode.properties.fileStorageId.substring(
          0,
          childNode.properties.fileStorageId.length - toRemove.length,
        );
      }
    } else {
      const response = makeNodeAbsolutePathRecursive(childNode, relativePath + "/" + childNode.value);
      if (response !== undefined) {
        return response;
      }
    }
  }
}

export function makeZipPath(filePath, nodeAbsolutePath) {
  //console.log(filePath, nodeAbsolutePath);
  if (filePath.startsWith("/Uploaded")) {
    filePath = "User Files" + filePath;
  }
  if (filePath.startsWith(nodeAbsolutePath)) {
    return filePath.substring(nodeAbsolutePath.length);
  } else {
    return filePath;
  }
}

export async function removeAll() {
  const fileList = await getAll();
  const fileIdsList = fileList.map((file) => file.id);
  removeList(fileIdsList);
}

async function getAll(predicate) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(ZIP_DOWNLOADS_DB, "readonly");
    const store = tx.objectStore(ZIP_DOWNLOADS_DB);
    const collectFilesRequest = store.openCursor();
    const fileList = [];
    collectFilesRequest.onsuccess = function (event) {
      const cursor = event.target.result;
      if (cursor) {
        if (predicate === undefined || predicate(cursor.value)) {
          fileList.push(cursor.value);
        }
        cursor.continue();
      } else {
        resolve(fileList);
      }
    };
    collectFilesRequest.onerror = () => reject("Error getting completed files list");
    tx.oncomplete = function () {
      db.close();
    };
  });
}

async function removeList(fileIdsList) {
  //console.log("file ids to remove:", fileIdsList);
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(ZIP_DOWNLOADS_DB, "readwrite");
    const store = tx.objectStore(ZIP_DOWNLOADS_DB);

    for (const fileId of fileIdsList) {
      const deleteRequest = store.delete(fileId);
      //deleteRequest.onsuccess = resolve;
      deleteRequest.onerror = () => reject("Error deleting file");
    }
    resolve();

    tx.oncomplete = function () {
      db.close();
    };
  });
}

async function saveUploadToDB(id, path, zipPath, authToken, keySignature, size) {
  const filesUrl = `${baseUrl}/api/${apiVersion}/files`;
  const entity = { id, filesUrl, path, zipPath, authToken, keySignature, size, completed: false };
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(ZIP_DOWNLOADS_DB, "readwrite");
    const store = tx.objectStore(ZIP_DOWNLOADS_DB);
    //console.log("saving to db:", entity);
    const addRequest = store.add(entity);
    addRequest.onsuccess = resolve;
    addRequest.onerror = () => reject("Error saving file");

    tx.oncomplete = function () {
      db.close();
    };
  });
}

async function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(ZIP_DOWNLOADS_DB, 1);

    request.onerror = function (event) {
      reject("Error opening database");
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(ZIP_DOWNLOADS_DB)) {
        db.createObjectStore(ZIP_DOWNLOADS_DB, { keyPath: "id" });
      }
    };
  });
}
